import React from 'react';

/**
 * v2.6 — neutral "Excluded" chip marking a logging-exempt user wherever
 * they're surfaced: the Team table's Excluded group, and the drill-in
 * Today / Summary header. Deliberately muted (no status colour) — it's an
 * attribute, not a warning. `size="sm"` for inline use next to a banner.
 */
export function ExcludedBadge({ size = 'md' }) {
  const sm = size === 'sm';
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: sm ? '2px 7px' : '3px 9px',
        borderRadius: 999,
        background: 'var(--sp-bg-muted)',
        border: '1px solid var(--sp-border)',
        color: 'var(--sp-fg-2)',
        fontSize: sm ? 10.5 : 11.5,
        fontWeight: 700,
        letterSpacing: '0.02em',
        whiteSpace: 'nowrap',
      }}
    >
      <span
        style={{
          width: 5,
          height: 5,
          borderRadius: 999,
          background: 'var(--sp-fg-4)',
          flex: 'none',
        }}
      />
      Excluded
    </span>
  );
}
